import { createContext, useContext } from 'react';

type RefetchContextType = {
	refetch: () => void;
	isLoading: boolean;
};

export const RefetchContext = createContext<RefetchContextType | null>(null);

export const useRefetchContext = () => {
	const refetchContext = useContext(RefetchContext);

	if (refetchContext == null) {
		throw new Error('Version details refetch provider was not found');
	}

	return refetchContext;
};
